import './table.scss';
import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import TagsList from '../tagsList/TagsList';

const Table = ({ styleTable = '', data }) => {
    const { t } = useTranslation();
    const classes = classnames(styleTable, {
        'b-table': true
    });

    return (
        <div className={classes}>
            {data.map(([key, value]) => {
                if (key === 'available_countries') {
                    return (
                        <div key={key} className="row">
                            <div className="key">{t(key)}</div>
                            <div className="value flex" data-testid={key}>{value}</div>
                        </div>
                    );
                }
                if (!Array.isArray(value)) {
                    if (
                        typeof value !== 'undefined' &&
                        value !== null &&
                        value !== ''
                    ) {
                        if (typeof value === 'boolean') {
                            return (
                                <div key={key} className="row">
                                    <div className="key">{t(key)}</div>
                                    <div className="value" data-testid={key}>
                                        {value ? t('yes') : t('no')}
                                    </div>
                                </div>
                            );
                        }
                        return (
                            <div key={key} className="row">
                                <div className="key">{t(key)}</div>
                                <div className="value" data-testid={key}>{value}</div>
                            </div>
                        );
                    }

                    return '';
                }

                if (value.length > 0) {
                    if (typeof value[0] !== 'string') {
                        return (
                            <div key={key} className="row with-table">
                                <div className="key">{t(key)}</div>
                                <Table
                                    styleTable={styleTable}
                                    data={value}
                                />
                            </div>
                        );
                    }
                    return (
                        <div key={key} className="row">
                            <div className="key">{t(key)}</div>
                            <TagsList items={value} />
                        </div>
                    );
                }

                return <div key={key} className="row" />;
            })}
        </div>
    );
};

export default Table;
